import React from 'react'
import { useTranslation } from "react-i18next";
import { Card, Row } from "react-bootstrap"
import StadisticCard from './StadisticCard';
import { Icon, IconButton } from '@fluentui/react';
import { __onGoToBoardCartera, __onGoToBoardHome, __onGoToKPIHome } from '../../../../common/SystemRedirections';
import { useHistory } from "react-router-dom";
import { enum__Clients } from '../../../../common/Dictionaries';
import { authGetClient } from '../../../../actions/auth-action';

function HomeStadistic(props) {
    const { t } = useTranslation();
    const history = useHistory();

    //Parametros de entrada.
    //const inputParam_ObjectMessageList = props.objectMessageList;
    const inputParam_ObjStadisticData = props.objStadisticData !== null && props.objStadisticData !== undefined ? props.objStadisticData : null;
    const inputParam_SelectedStadisticCard = props.selectedStadisticCard !== null && props.selectedStadisticCard !== undefined ? props.selectedStadisticCard : null;
    const inputParam_SetSelectedStadisticCard = props.setSelectedStadisticCard !== null && props.setSelectedStadisticCard !== undefined ? props.setSelectedStadisticCard : null;
    const inputParam_SetFireOrderData = props.setFireOrderData !== null && props.setFireOrderData !== undefined ? props.setFireOrderData : null;
    const inputParam_SetObjHomeStadisticData = props.setObjHomeStadisticData !== null && props.setObjHomeStadisticData !== undefined ? props.setObjHomeStadisticData : null;
    
    let totalBoard = 0;
    let totalGapBorad = 0;
    let totalGap = 0;
    let totalDataserie = 0;
    let totalDataserieValue = 0;

    let totalBadValue = 0;
    let totalRegularValue = 0;
    let totalFineValue = 0;
    let totalGapAnalyse = 0;
    
    if (inputParam_ObjStadisticData.data !== null) {
        for (let index = 0; index < inputParam_ObjStadisticData.data.length; index++) {
            const element = inputParam_ObjStadisticData.data[index];
        
            totalBoard = totalBoard += (element.type === "Board" ? 1 : 0);
            totalGapBorad = totalGapBorad += (element.type === "Gap" ? 1 : 0);

            totalDataserie = totalDataserie += (element.nTotalDataserie !== undefined ? element.nTotalDataserie : 0);
            totalDataserieValue = totalDataserieValue += (element.nTotalDataserie_value !== undefined ? element.nTotalDataserie_value : 0);
            
            totalBadValue = totalBadValue += (element.nTotalDataserie_badvalue !== undefined ? element.nTotalDataserie_badvalue : 0);
            totalRegularValue = totalRegularValue += (element.nTotalDataserie_regularvalue !== undefined ? element.nTotalDataserie_regularvalue : 0);
            totalFineValue = totalFineValue += (element.nTotalDataserie_finevalue !== undefined ? element.nTotalDataserie_finevalue : 0);
            
            totalGap = totalGap += (element.nTotalDataserie_gapvalue !== undefined ? element.nTotalDataserie_gapvalue : 0);
            totalGapAnalyse = totalGapAnalyse += (element.nTotalDataserie_gapanalyzevalue !== undefined ? element.nTotalDataserie_gapanalyzevalue : 0);
        }
    }

    const container = {
        display: "flex",
        justifyContent: "center",
        margin: "0px",
        padding: "0px"
    };

    const cards = [
        { class: "col pt-2", title: t('data-lang-lbl-totalboard'), type: "isTotalBoard", amount: totalBoard, icon: "Table", borderTop: "5px solid #a1a1a1", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-totalgap'), type: "iTotalGap", amount: totalGapBorad, icon: "StackedColumnChart2", borderTop: "5px solid #a1a1a1", display: true },
        { class: "col pt-2", title: `${t('data-lang-lbl-totaldataserie')} / ${t('data-lang-lbl-totaldataserievalue')}`, type: "isTotalDataserie", amount: `${totalDataserie} / ${totalDataserieValue}`, icon: "Chart", borderTop: "5px solid #A1B8E1", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-totalbadvalue'), type: "isTotalBadValue", amount: totalBadValue, icon: "DrillDown", borderTop: "5px solid #d93b3b", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-totalregularvalue'), type: "isTotalRegularValue", amount: totalRegularValue, icon: "RadioBtnOn", borderTop: "5px solid #ECA700", display: true },
        { class: "col pt-2", title: t('data-lang-lbl-totalfinevalue'), type: "isTotalFineValue", amount: totalFineValue, icon: "DrillDown", borderTop: "5px solid #25aa34", display: true, rotation: 'rotate(180deg)' },
        { class: "col pt-2", title: `${t('data-lang-lbl-gaps')} / ${t('data-lang-lbl-totalgapanalyse')}`, type: "isTotalGapAnalyse", amount: `${totalGap} / ${totalGapAnalyse}`, icon: "TimelineProgress", borderTop: "5px solid #a1a1a1", display: true },
    ];

    return (
        <Card className='book-info-form'>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>
                        { t('data-lang-boxname-kpistadistic') }
                    </b>
                    <div className='book-toolbar'>
                        <div className='toolbar d-flex my-auto' id={"filter-board-field-callout-button"}>
                            <div className='pe-2' style={{paddingTop: "5px", fontSize: "16px"}}>{t('data-lang-lbl-view2')} </div>
                            <IconButton title='Seleccionado' iconProps={{iconName: "QuadColumn"}} disabled={true} styles={{ root: {transform: "rotate(-90deg)"}, icon: { fontSize: 20 } }} />
                            <IconButton title='Seleccionar' onClick={() => __onGoToBoardHome(history)} iconProps={{iconName: "ViewDashboard"}} styles={{ icon: { fontSize: 20 } }} />
                            <IconButton title='Cartera de contratos' onClick={() => __onGoToBoardCartera(history)} iconProps={{iconName: "FabricReportLibrary"}} styles={{ icon: { fontSize: 20 } }} />
                        </div>
                    </div>
                </Card.Title>
            </Card.Header>
            <Card.Body className='p-0 pb-2'>
                <Row style={ container }>
                    {
                        cards.map((card, index) => (
                            <div key={index} className={`${card.class} ${card.display ? "d-unset" : "d-none"}`} style={{cursor: "pointer", padding: "0px", minWidth: "120px"}} >
                                <StadisticCard
                                    item={ card }
                                    setSelectedStadisticCard={inputParam_SetSelectedStadisticCard}
                                    selectedStadisticCard={inputParam_SelectedStadisticCard}
                                    setFireOrderData={inputParam_SetFireOrderData}
                                    setObjHomeStadisticData={inputParam_SetObjHomeStadisticData} />
                            </div>
                        ))
                    }
                </Row>
            </Card.Body>
            <Card.Footer>

            </Card.Footer>
        </Card>


    );
}

export default HomeStadistic;

